export const StarBoldOutlineBannerRatingGiven = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="38" viewBox="0 0 40 38" width="40">
    <path
      d="m17.868 1.54054-4.8625 9.73746-10.99673 1.5375c-1.9449963.2929-2.693072 2.6357-1.271728 4.0268l7.854798 7.541-1.87019 10.6161c-.29923 1.9035 1.79538 3.3678 3.51595 2.4893l9.7998-5.0518 9.725 5.0518c1.7206.8785 3.8152-.5858 3.516-2.4893l-1.8702-10.6161 7.8548-7.541c1.4213-1.3911.6732-3.7339-1.2718-4.0268l-10.9219-1.5375-4.9373-9.73746c-.8229-1.68392-3.3663-1.757134-4.264 0z"
      fill="#292b29"
    />
  </svg>
);
